import { useState, useEffect } from "react";
import { captureException } from '@sentry/nextjs';

import type { User } from "./useUser";
import type { WillTypes } from "@/types";
import APIService from "@/util/api-service";
import SessionStorageService from "@/util/session-storage-service";

/*
*   Hook for getting unfinished will for user if such exists. Is used to skip payment if non completed will exists.
*/
const useWill = ( user: User|null, type: WillTypes ) => {

    const [gettingWill, setGettingWill] = useState(true);
    const [will, setWill] = useState<null | any>(null);

    useEffect( () => {
        if ( user && ! will ) {

            // Get will from session storage if exists, else get from db
            const sessionWill = SessionStorageService.getWill( type );
            if ( sessionWill ) {
               
                setWill( sessionWill ); 
                setGettingWill(false);
            }
            else {
                APIService.postWithUidToken( `/api/product/get-unarchived/${type.toLowerCase()}`, {} ) 
                .then( ( will ) => {
                    setWill( will.data );
                  
                    // Only cache editable wills
                    if ( will.data ) {
                        if ( will.data.status === 'editable' ) {
                            SessionStorageService.setWill( will.data, type );
                        }
                    }

                    setGettingWill(false);
                })
                .catch( ( error ) => {
                    captureException(error)
                    setWill( null );
                })  
            }
   
        }
    }, [user]); 

    return { will, setWill, gettingWill };
}

export default useWill;